<template>
  <praktische-afspraken/>
</template>

<script>
import PraktischeAfspraken from '../components/OpbouwPlechtigheid/PraktischeAfspraken.vue'

export default {
  name: 'PraktischeAfsprakenView',
  components: {
    PraktischeAfspraken
  }
}
</script>
